import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

const UserMenuHeaderDefaultBox = styled.div`
    position: relative;
    flex: unset;
    padding: 1.4rem 0 1.4rem 0;
    background-color: ${({theme}) => theme.colors.background};
`;

const UserMenuHeaderCasino888Box = styled(UserMenuHeaderDefaultBox)`
    padding: 1.6rem 0 1.7rem 0;
`;

const UserMenuHeaderCasino777Box = styled(UserMenuHeaderDefaultBox)`
    background-color: ${({theme}) => theme.colors.logoBackground };
`;

const UserMenuHeaderMrGreenBox = styled(UserMenuHeaderDefaultBox)`
    padding: 1.3rem 0 1.3rem 0;
`;

export const UserMenuHeaderBox = styledByTheme(UserMenuHeaderDefaultBox)
    .forCasino888(UserMenuHeaderCasino888Box)
    .forCasino777(UserMenuHeaderCasino777Box)
    .forMrGreen(UserMenuHeaderMrGreenBox)
    .forSI(UserMenuHeaderMrGreenBox)
    .apply();
